import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment';

export interface ChatMessage {
  role: 'user' | 'assistant' | 'system';
  content: string;
  formattedContent?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  constructor(private http: HttpClient) { }

  sendMessage(userMessage: string, history: ChatMessage[]): Observable<any> {
    if (!environment.ai.apiKey) {
      console.warn('AI API Key is missing. Please add it to environment.ts');
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${environment.ai.apiKey}`
    });
    const modelName = 'gemini-2.5-flash';

    // 2. Construct the URL
    const url = `https://generativelanguage.googleapis.com/v1beta/models/${modelName}:generateContent?key=${environment.ai.apiKey}`;


    const contents = history.map(msg => ({
      role: msg.role === 'assistant' ? 'model' : 'user',
      parts: [{ text: msg.content }]
    }));

    // Add current message
    contents.push({
      role: 'user',
      parts: [{ text: userMessage }]
    });

    const body = {
      contents: contents
    };

    return this.http.post(url, body);
  }
}
